import { Checkbox } from "~/atoms/checkbox";

interface Props {
  id: string;
  label: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
}

const CheckboxWithLabel = ({
  id,
  label,
  checked,
  disabled = false,
  onCheckedChange,
}: Props) => {
  return (
    <div className="flex flex-row items-start space-y-0 space-x-3">
      <Checkbox
        id={id}
        disabled={disabled}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <label htmlFor={id} className="truncate text-sm" title={label}>
        {label}
      </label>
    </div>
  );
};

export default CheckboxWithLabel;
